import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 md:mb-14 gap-6">
          <div className="lg:max-w-md">
            <p className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">Browse</p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              Explore Product Categories
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
            Browse through our carefully organized spreadsheet categories. Each category contains curated products with detailed pricing and availability information.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer overflow-hidden"
            >
              <div className="w-full aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex items-center gap-2 p-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-100 transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-xs text-foreground-500 group-hover:text-primary-600 transition-colors`}></i>
                </span>
                <span className="text-xs font-medium text-foreground-700 group-hover:text-foreground-950 whitespace-nowrap transition-colors">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}